module.exports = __webpack_public_path__ + "static/media/ico-repo-files.ed5e727e.svg";